<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <v-container>
                <v-row class="pa-5 mb-5">
                    <div>
                        <h2>Administrators</h2>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                        <onboardadmin-modal v-if="can('can_manage_admins')" @reload = "reload"/>
                    </div>
                </v-row>
                <dtunes-loader :loading="loading"></dtunes-loader>
                <admin-table @reload = "reload" :admins="admins" />
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
// =========== IMPORT COMPONENTS =========
import OnboardadminModal from '../components/onboard-admin-modal.vue'
import AdminTable from  '../components/admin-table.vue'
import DtunesLoader from "@/components/dtunes-loader.vue"

// ============= IMPORT SERVICES ===========
import { AdminService } from "@/services";

export default {
    components:{
        OnboardadminModal,
        AdminTable,
        DtunesLoader
    },
    data: () => ({
        admins:[],
        loading:false
    }),
    mounted(){
        this.getAdmins();
    },
    methods:{
        async getAdmins(){
            try {
                this.loading = true
                const data = await AdminService.getAdmins();
                this.loading = false
                this.admins = data;
            } catch (error) {
                console.log(error);
                this.loading = false
            }
        },
        async reload(){
            await this.getAdmins()
        }
    }
}
</script>